import React from "react";

import { useTranslation } from "react-i18next";

import { useFormContext, Controller } from "react-hook-form";

import { DropdownDevise, InputGroup } from "@components/tailwindComponents";

import { MAX_ANNUAL_SALARY } from "@helpers/_constants";
import { formatToNumber } from "@helpers/_functions";

export default function AnnualSalaryInput({ readOnly = false }) {
  const { control } = useFormContext();
  const { t: translate } = useTranslation([
    "pages.employés.parcours&Certifications",
    "message"
  ]);
  return (
    <div className="arh-mb-3">
      <div className="arh-relative arh-flex arh-w-full">
        <Controller
          control={control}
          name="salary"
          rules={{
            validate: {
              annualSalaryMax: (value) => {
                if (value === undefined || value === null || value === "") {
                  return true;
                }

                const amount = Number(value);
                return Number.isFinite(amount) && amount <= MAX_ANNUAL_SALARY;
              }
            }
          }}
          render={({
            field: { onChange, name, value },
            fieldState: { invalid }
          }) => (
            <InputGroup
              name={name}
              onChange={(event) => {
                const nextValue = formatToNumber(event.target.value);
                onChange(nextValue);
              }}
              value={value}
              invalid={invalid}
              disabled={readOnly}
              placeholder={translate("Salaire")}
              label={translate("Salaire Annuel")}
              classParent="arh-w-full"
              classContent="arh-w-24"
              content={
                <DropdownDevise
                  control={control}
                  rules={{ required: true }}
                  disable={readOnly}
                />
              }
            />
          )}
        />
      </div>
    </div>
  );
}
